<template>
  <form id="modifyPwdForm">
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.User.password')}}:</div>
            <input
              id="md-passwd"
              class="e-input e-input-group"
              type="password"
              name="password"
              maxlength="20"
              v-model="password"
              :placeholder="$t('Security.placeholder.password')"
            />
          </div>
          <div class="error"></div>
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">{{$t('Security.User.confirmpwd')}}:</div>
            <input
              id="md-cpasswd"
              class="e-input e-input-group"
              type="password"
              name="confirmPassword"
              maxlength="20"
              v-model="confirmPassword"
              :placeholder="$t('Security.placeholder.confirmpwd')"
            />
          </div>
          <div class="error"></div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'ModifyPasswd',
  data() {
    return {
      password: '',
      confirmPassword: '',
      formValidator: '',
      validateOptions: {
        customPlacement: function(inputElement, errorElement) {
          inputElement = inputElement.closest('.form-group').querySelector('.error');
          inputElement.parentElement.appendChild(errorElement);
        },
        rules: {
          'password': {
            required: [true, `${this.$t('Security.placeholder.password')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'confirmPassword': {
            required: [true, `${this.$t('Security.placeholder.confirmpwd')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          }
        }
      }
    }
  },
  methods: {
    initStrategy() {
      let pwdStrategy = JSON.parse(localStorage.getItem('pwdStrategy'));
      this.validateOptions.rules.password.minLength = [pwdStrategy['pwd.minLength'], `${this.$t('Security.validate.minLength')}`.replace('{0}', pwdStrategy['pwd.minLength'])];
      this.validateOptions.rules.confirmPassword.minLength = [pwdStrategy['pwd.minLength'], `${this.$t('Security.validate.minLength')}`.replace('{0}', pwdStrategy['pwd.minLength'])];
      if(pwdStrategy['pwd.constitute']==1) {
        this.validateOptions.rules.password.regex = ['^[a-zA-Z0-9]+$', `${this.$t('Security.validate.noSpecial')}`];
        this.validateOptions.rules.confirmPassword.regex = ['^[a-zA-Z0-9]+$', `${this.$t('Security.validate.noSpecial')}`];
      }else {
        this.validateOptions.rules.password.regex = ["[!#$%&*^\'()+,-./:;<=>?@\\[\\\\\\]^`\\{_|\\}~]+", `${this.$t('Security.validate.special')}`];
        this.validateOptions.rules.confirmPassword.regex = ["[!#$%&*^\'()+,-./:;<=>?@\\[\\\\\\]^`\\{_|\\}~]+", `${this.$t('Security.validate.special')}`];
      }
      this.formValidator = new FormValidator('#modifyPwdForm', this.validateOptions);
    },
    validate() {
      let validateStatus = this.formValidator.validate();
      if (this.password != this.confirmPassword) {
        document.getElementById('md-cpasswd').parentElement.classList.add('e-error');
        document.getElementById('md-cpasswd').parentElement.nextElementSibling.className = 'e-error';
        document.getElementById('md-cpasswd').parentElement.nextElementSibling.innerHTML = `${this.$t('Security.pwdNotMatch')}`;
        validateStatus = false;
      } else {
        document.getElementById('md-cpasswd').parentElement.classList.remove('e-error');
        document.getElementById('md-cpasswd').parentElement.nextElementSibling.className = 'error';
        document.getElementById('md-cpasswd').parentElement.nextElementSibling.innerHTML = '';
      }
      return validateStatus;
    },
    getModifyParams() {
      return this.password;
    }
  }
}
</script>
